document.addEventListener('click', function(e) {
  let swatch = e.target.closest('.card-color-swatch');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  let colorValue = swatch.dataset.color;
  let cardWrapper = swatch.closest('.card-wrapper');
  if (!cardWrapper) return;

  let colorLabel = cardWrapper.querySelector('.wb_popup_variant label[data-value="' + colorValue + '"]');
  if (colorLabel) colorLabel.click();

  let popupBtn = cardWrapper.querySelector('.wb_select_btn');
  if (popupBtn) popupBtn.click();
});
document.addEventListener('click', function(e) {
  let count = e.target.closest('.card-swatch-count');
  if (!count) return;
  e.preventDefault();
  e.stopPropagation();
  let cardWrapper = count.closest('.card-wrapper');
  if (!cardWrapper) return;
  let firstSwatch = cardWrapper.querySelector('.card-color-swatch');
  if (!firstSwatch) return;
  let colorValue = firstSwatch.dataset.color;
  let colorLabel = cardWrapper.querySelector('.wb_popup_variant label[data-value="' + colorValue + '"]');
  if (colorLabel) colorLabel.click();
  let popupBtn = cardWrapper.querySelector('.wb_select_btn');
  if (popupBtn) popupBtn.click();
});